module.exports = __webpack_public_path__ + "static/media/image_incapacidad_pdf.0a2c9531.webp";